import { render, staticRenderFns } from "./ExaminerDashboard.vue?vue&type=template&id=aa28f890"
import script from "./ExaminerDashboard.vue?vue&type=script&lang=js"
export * from "./ExaminerDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports